import { axiosClient } from '@services/clients'

export async function getUserBonuses(playerId) {
  const { data } = await axiosClient(`/assignments/${playerId}?page_size=100`)
  return data
}

export async function getBonusAssignments(bonusId) {
  const { data } = await axiosClient(`/assignments?bonusId=${bonusId}`)
  return data
}

// `playerId` is sent so the backend can enforce that the assignment actually
// belongs to the player whose page the operator is on. Back-office callers skip
// the implicit ownership check, and the server-side guard only runs when
// player_id is present, so omitting it would leave the cancel unverified.
export async function cancelAssignment(assignmentId, reason, playerId) {
  const { data } = await axiosClient.post('/cancel', {
    bonus_assignment_uid: assignmentId,
    reason,
    player_id: playerId,
  })
  return data
}
